import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { ElMessage } from 'element-plus'; // 假设使用 Element Plus 的消息提示

// 定义响应数据结构
interface ResponseData<T = any> {
  code: number;
  message: string;
  data: T;
}

// 创建 Axios 实例
const service: AxiosInstance = axios.create({
  baseURL: '/api', // 假设 API 基础路径为 /api
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // 在发送请求之前做些什么
    // 例如：添加 token
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error: AxiosError) => {
    // 对请求错误做些什么
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse<ResponseData>) => {
    // 对响应数据做点什么
    const res = response.data;

    // 假设 code 为 200 表示成功
    if (res.code === 200) {
      return res.data;
    } else {
      // 业务错误处理
      ElMessage.error(res.message || 'Error');
      return Promise.reject(new Error(res.message || 'Error'));
    }
  },
  (error: AxiosError) => {
    // HTTP 状态码错误处理
    let message = '';
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = '请求错误 (400)';
          break;
        case 401:
          message = '未授权，请重新登录 (401)';
          // 可以在这里跳转到登录页
          break;
        case 403:
          message = '拒绝访问 (403)';
          break;
        case 404:
          message = '请求地址出错 (404)';
          break;
        case 429:
          message = '请求过于频繁，请稍后再试 (429)';
          break;
        case 500:
          message = '服务器内部错误 (500)';
          break;
        default:
          message = `连接错误 (${error.response.status})!`;
      }
    } else {
      message = '网络连接失败，请检查网络！';
    }
    
    ElMessage.error(message);
    console.error('Response Error:', error);
    return Promise.reject(error);
  }
);

// 封装请求方法
const request = {
  get<T = any>(url: string, params?: any, config?: AxiosRequestConfig): Promise<T> {
    return service.get(url, { params, ...config });
  },
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return service.post(url, data, config);
  },
  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return service.put(url, data, config);
  },
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return service.delete(url, config);
  },
};

export default request;
